// Define the BaseMessage structure
const BaseMessage = {
  type: '', // String describing the type of message
  component: null, // React component to render
  sender: '', // String identifying the sender (e.g., 'client', 'response')
  showAvatar: false, // Boolean indicating whether to show an avatar
  timestamp: new Date(), // Date object representing the timestamp of the message
  unread: false, // Boolean indicating whether the message is unread
  customId: '', // Optional string for custom ID
  props: null // Optional props object
};

// Define the MessageTypes extending BaseMessage
const MessageTypes = {
  ...BaseMessage,
  text: '' // String for the message text
};

// Define the QuickButtonTypes structure
const QuickButtonTypes = {
  label: '', // String label for the quick button
  value: '', // String or number value associated with the button
  component: null // React component to render for the button
};

// Define the Link extending BaseMessage
const Link = {
  ...BaseMessage,
  title: '', // String title of the link
  link: '', // String URL of the link
  target: '' // String target of the link (e.g., '_blank')
};

// Define the LinkParams structure
const LinkParams = {
  link: '', // String URL of the link
  title: '', // String title of the link
  target: '' // Optional string target of the link
};

// Define the CustomCompMessage extending BaseMessage
const CustomCompMessage = {
  ...BaseMessage,
  props: null // Props object for the custom component
};

// Define the BehaviorState structure
const BehaviorState = {
  showChat: false, // Boolean indicating whether the chat widget is visible
  disabledInput: false, // Boolean indicating whether the input is disabled
  messageLoader: false // Boolean indicating whether a message loader is active
};

// Define the MessagesState structure
const MessagesState = {
  messages: [], // Array containing messages of different types (MessageTypes, Link, CustomCompMessage)
  badgeCount: 0 // Number representing the badge count for unread messages
};

// Define the QuickButtonsState structure
const QuickButtonsState = {
  quickButtons: [] // Array containing QuickButtonTypes objects
};

// Define the ImageState structure
const ImageState = {
  src: '', // String representing the image source URL
  alt: '', // Optional string representing the image alternate text
  width: 0, // Number representing the image width
  height: 0 // Number representing the image height
};

// Define the FullscreenPreviewState extending ImageState
const FullscreenPreviewState = {
  ...ImageState,
  visible: false // Optional boolean indicating whether the fullscreen preview is visible
};

// Define the GlobalState combining all state structures
const GlobalState = {
  messages: MessagesState,
  behavior: BehaviorState,
  quickButtons: QuickButtonsState,
  preview: FullscreenPreviewState
};

// Export the structures
module.exports = {
  BaseMessage,
  MessageTypes,
  QuickButtonTypes,
  Link,
  LinkParams,
  CustomCompMessage,
  BehaviorState,
  MessagesState,
  QuickButtonsState,
  ImageState,
  FullscreenPreviewState,
  GlobalState
};
